import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/acesso/localidade/';

class LocalidadeService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
        });
    }

    findAllByFiltro(filtro) {
        return axios.get(API_URL + 'filter?filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findAllByFiltroSemIbge(filtro, codigoIbge) {
        return axios.get(API_URL + 'filterSemIbge?filtro=' + filtro + '&codigoIbge=' + codigoIbge, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findAllByFiltroIbge(filtro) {
        return axios.get(API_URL + 'filterComIbge?filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findAllByCep(cep) {
        return axios.get(API_URL + 'filter?cep=' + cep, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findAllById(id) {
        return axios.get(API_URL + 'findById?id=' + id, { headers: this.headers });
    }
}

export default new LocalidadeService();